import { Component } from '@angular/core';
import { GridButton } from 'src/app/core/models/grid-button.model';
import { GridColumn } from 'src/app/core/models/grid-column.model';
import { GridSearchFilter } from 'src/app/core/models/grid-search-filter.model';
import { describeInterval } from '../../models/inspection.models';

@Component({
    selector: 'app-inspection-types',
    templateUrl: './inspection-types.component.html',
    standalone: false
})
export class InspectionTypesComponent {
  buttons: GridButton[] = [
    { label: 'Edit', link: '/workshop/inspection-types/edit/:id', type: 'btn-warning' } as GridButton,
  ];
  columns: GridColumn[] = [
    { active: true, label: 'Name', field: 'name' } as GridColumn,
    { active: true, label: 'Interval', field: 'intervalNumber', value: (v, r) => describeInterval(r) } as GridColumn,
    { active: true, label: 'Colour', field: 'colour',
      value: (v) => /^#[0-9a-fA-F]{6}$/.test(v) ? `<span style="display:inline-block;width:1.2rem;height:1.2rem;border-radius:4px;background:${v};vertical-align:middle"></span> ${v}` : '' } as GridColumn,
    { active: true, label: 'Active', field: 'active', value: (v) => v ? 'Yes' : 'No' } as GridColumn,
  ];
  searchFields: string[] = ['name'];
  searchFilters: GridSearchFilter[] = [{ field: 'name', label: 'Name' } as GridSearchFilter];
}
